import { getAuth, signInWithCustomToken } from 'firebase/auth';
import gql from 'graphql-tag';

import { api } from '../../network';
import actionTypes from './constants';

/* API REQUEST UTILS */

// -----------------------------------------------------------------------------
// AUTH (PUBLIC REST)
// -----------------------------------------------------------------------------

/* */
export const signIn = (email, password) => api.post('login', { username: email, password }).then(({ auth: isAuth, token }) => {
    const auth = getAuth();
    if (!isAuth && !token) return null;
    return signInWithCustomToken(auth, token);
  });

/* */
export const signUp = (email, password) => api
    .post('register', { username: email, password })
    .then(({ auth: isAuth, token }) => {
      const auth = getAuth();
      if (!isAuth && !token) return null;
      return { auth, token };
    })
    .then(({ auth, token }) => auth && token && signInWithCustomToken(auth, token));

/* */
export const forgotPassword = (email, golfId) => api.post('password/forgot', { email, golfId });

/* */
export const forgotPasswordCheck = (hash) => api.get(`password/forgot/${hash}`);

/* */
export const resetPassword = (hash, params, autoLogin) => api
    .post(`password/reset/${hash}`, params)
    .then(({ auth, token }) => autoLogin && auth && token && signInWithCustomToken(auth, token));

/* */
export const activation = (hash, params) => api.post(`register/activation/${hash}`, params);

export const getGolfInfo = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_GOLF}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => ({ golf: data.getGolf }));

/* */
export const getMatch = (client, variables) => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_MATCH_ACCOUNT}
      `,
      variables,
    })
    .then((res) => res.data)
    .then(({ getMatchAccount }) => ({ match: getMatchAccount }));

/* */
export const changePassword = (client, variables) => client.mutate({
    mutation: gql`
      ${actionTypes.gql.CHANGE_PASSWORD}
    `,
    variables,
  });

/* */
export const changeLogin = (client, variables) => client.mutate({
    mutation: gql`
      ${actionTypes.gql.CHANGE_LOGIN}
    `,
    variables,
  });

/* */
export const setUserOption = (client, option) => client.mutate({
    mutation: gql`
      ${actionTypes.gql.SET_USER_OPTION}
    `,
    variables: { option },
  });

/* */
export const getGolfInterests = (client, variables) => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_GOLF_INTERESTS}
      `,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.getGolfInterests);

/* */
export const getGolfReciprocities = (client, variables) => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_GOLF_RECIPROCIIES}
      `,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.getGolfReciprocities);

// /* */
// export const registerFinal = (client, variables) => (
//   client.mutate({
//     mutation: gql`${actionTypes.gql.REGISTER_FINAL}`,
//     variables,
//   })
//     .then(res => res.data)
//     .then(data => ({ account: data.setAccount })));
